/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: index.ts
 * Class: index.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { DashboardState } from './types';
import { RootState } from '../types';
import { getDefaultState } from '../utils';

export const state: DashboardState = {
  gamecloudEdit: undefined,
  cloudPrice: getDefaultState(),
  editOrder: getDefaultState(),
  getServer: getDefaultState(),
  updateServer: getDefaultState(),
  error: false,
};

const namespaced = true;

export const dashboard: Module<DashboardState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
